export default __webpack_public_path__ + "static/media/throne.15d7af63.webp";